(ns ui.context-menu
  (:require ["@radix-ui/react-context-menu" :as RadixMenu]
            ["lucide-react" :refer [ExternalLink]]
            [ui.utils :refer [clsx separate-props]]))

(defn context-menu-sub [& args]
  (let [[{:keys [content] :as props} children] (separate-props args)]
    [:> RadixMenu/Sub {}
     (into
      [:> RadixMenu/SubTrigger (-> props
                                   (dissoc :content)
                                   (update :class clsx "relative flex cursor-default select-none items-center rounded-xs px-2 py-1.5 text-sm outline-hidden transition-colors focus:bg-kleene-neutral-05 dark:focus:bg-kleene-dark-04 data-disabled:pointer-events-none data-disabled:opacity-50"))]
      children)

     [:> RadixMenu/Portal
      [:> RadixMenu/SubContent {:class "z-999999 min-w-[8rem] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-md bg-kleene-background border-kleene-neutral-05 dark:border-kleene-dark-03"}
       content]]]))


(defn context-menu-item
  [& args]
  (let [[props children] (separate-props args)]
    (into
     [:> RadixMenu/Item
      (some-> props (update :class clsx "relative flex cursor-default select-none items-center rounded-xs px-2 py-1.5 text-sm outline-hidden focus:bg-kleene-neutral-05 dark:focus:bg-kleene-dark-04 transition-colors data-disabled:pointer-events-none data-disabled:opacity-50"))]
     children)))


(defn context-menu-link
  [props children]
  [:> RadixMenu/Item
   (some-> props (update :class clsx "relative flex cursor-default select-none items-center rounded-xs px-2 py-1.5 text-sm outline-hidden focus:bg-kleene-neutral-05 dark:focus:bg-kleene-dark-04 transition-colors data-disabled:pointer-events-none data-disabled:opacity-50"))
   [:a {:target "_blank"
        :class  "block w-full"
        :href   (:link props)}
    children
    [:> ExternalLink {:size  16
                      :class "align-top ml-1"}]]])

(defn context-menu-content [& args]
  (let [[props children] (separate-props args)]
    [:> RadixMenu/Portal
     (into
      [:> RadixMenu/Content
       (-> props
           (update :class #(clsx "z-999999 min-w-[8rem] bg-white overflow-hidden rounded-md border border-kleene-neutral-03 dark:border-kleene-dark-03 dark:bg-kleene-dark-02 p-1 shadow-md" %)))]
      children)]))

(defn context-menu-root [& args]
  (let [[props children] (separate-props args)]
    (into [:> RadixMenu/Root props]
          children)))

(defn context-menu-trigger [& args]
  (let [[props children] (separate-props args)]
    (into [:> RadixMenu/Trigger props]
          children)))

(defn context-menu-separator [props]
  [:> RadixMenu/Separator (-> props
                              (update :class #(clsx "bg-kleene-layout-border h-px w-full my-0.5" %)))])

(defn context-menu-label [& args]
  (let [[props children] (separate-props args)]
    (into [:> RadixMenu/Label (-> props
                                  (update :class #(clsx "px-2 py-1 text-xs font-medium text-kleene-text-secondary" %)))]
          children)))

(defn context-menu
  [{:keys [content root-props]
    :or {root-props {}}} trigger]
  [context-menu-root root-props
   [context-menu-trigger {:asChild true}
    trigger]

   [context-menu-content content]])
